import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#009efd',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    poster: {
      color: '009efd',
    },
    // Disable h3 variant
    h6: {
      color: '#009efd'
    },
  },
});

export default theme;
